import React from "react";
import "./InvestedMarquee.css";
import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";
const InvestedMarquee = () => {
  const { t } = useTranslation();
  return (
    <div className="invested-marquee-container">
      <Marquee speed={20}>
        <div className="text-container">
          <p>
            {" "}
            {t("Over")} $10 billion {t("invested")} {t("in")} GameFi{" "}
            {t("projects")} {t("in")} {t("the")} {t("past")} {t("year")}.
          </p>
          <p>
            {" "}
            {t("Download")} Sportrex Gamers Wallet {t("and")} {t("earn")}{" "}
            {t("free")} SPT Token.
          </p>
          <p>
            {" "}
            {t("Over")} $10 billion {t("invested")} {t("in")} GameFi{" "}
            {t("projects")} {t("in")} {t("the")} {t("past")} {t("year")}.
          </p>
          <p>
            {" "}
            {t("Download")} Sportrex Gamers Wallet {t("and")} {t("earn")}{" "}
            {t("free")} SPT Token.
          </p>
        </div>
      </Marquee>
    </div>
  );
};

export default InvestedMarquee;
